<template>
    <div class="site__body site__body-order-entry">
        <div class="block-header block-header--has-breadcrumb block-header--has-title">
            <div class="container">
                <div class="block-header__body">
                    <div class="flexbox-page-info-container">
                        <div class="flex-item-page-info-breadcrumbs">
                            <nav class="breadcrumb block-header__breadcrumb" aria-label="breadcrumb">
                                <ol class="breadcrumb__list">
                                    <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                                    <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                                        <router-link to="/" class="breadcrumb__item-link">
                                            Home
                                        </router-link>
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--current">
                                        <router-link to="/return-list" class="breadcrumb__item-link">
                                            Return List
                                        </router-link>
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--last">
                                        <a href="#" class="breadcrumb__item-link">Return Items</a>
                                    </li>
                                    <li class="breadcrumb__title-safe-area" role="presentation"></li>
                                </ol>
                            </nav>
                        </div>

                        <div class="flex-item-page-info-title">
                            <h1 class="block-header__breadcrumb-slim">Return Items</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div class="block">
                <div class="container">
                    <div class="row">
                        <!-- <div class="col-12">
                            <base-message v-if="!isloading" :servermessages="servermessages"></base-message>
                        </div> -->
                        <div class="col-12 col-md-12" v-if="errormessages.length > 0 || servermessages.length > 0">
                            <div class="alert alert-danger mb-3">
                                <strong v-for="message in servermessages" :key="message">
                                    {{ message }} <br/>
                                </strong> 
                            </div>
                        </div>
                    </div>

                    <div class="">
                        <div class="cart__table cart-table">
                            <table class="cart-table__table">
                                <thead class="cart-table__head">
                                    <tr class="cart-table__row">
                                        <th class="cart-table__column cart-table__column--product cart-table__column--product-order-entry">Reason for Return</th>
                                    </tr>
                                </thead>
                                <tbody class="cart-table__body">
                                    <tr class="cart-table__row">
                                        <td class="cart-table__column cart-table__column--product">
                                            <div class="text-cart-item-number"><font class="text-cart-item-number"></font></div>
                                            <div class="text-cart-item-manufacturer"><font class="text-cart-item-manufacturer"></font></div>
                                            <div class="cart-table__quantity input-select">
                                                <select id="stock-order-vendor-select" class="form-control form-control-vendor-select select2-selection--vendor-select" v-model="formData.reason">
                                                    <option value="" selected>Select Return Reason</option>
                                                    <option v-for="(rs) in reasons" :key="rs.code" :value="rs.code">{{rs.description}}</option>
                                                </select>
                                            </div>
                                            <div class="block-space--layout--divider-order-entry"></div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="block-space--layout--divider-order-entry"></div>
                        <div class="widget-form-panel-mobile">
                            <div>
                                <strong>Instructions:</strong>
                                The ITEM NUMBER must be a part number, and not a name or description. The MFG CODE is optional, and is 3 characters in length (ex. ACDelco=ACD). Once you either click
                                "Validate Parts" or you use the CSV Upload, you will need to click "Remove Invalid Parts" if your list contains items that cannot be validated. Once your items are validated then click "Submit Return Request"
                                to submit the return.
                            </div>
                            <div class="block-space--layout--divider-order-entry"></div>
                            <div class="container-form">
                                <div class="container-form-button">
                                    <button type="button" class="btn btn-xs btn-checkout" :disabled="btnValidateEnable" @click="validate_parts">Validate Items</button>
                                    <button type="button" class="btn btn-xs btn-primary" :disabled="btnRemoveEnable" @click.prevent="remove_invalid">Remove Invalid Parts</button>
                                    <button type="button" class="btn btn-xs btn-grey"   @click.prevent="expand">Expand Form</button>
                                    <!-- <button type="button" class="btn btn-xs btn-grey">Download CSV Template</button> -->
                                    <a type="button" href="templates/Qwik-Order-Import-Template.csv" class="btn btn-xs btn-grey">Download CSV Template</a>
                                    <button type="button" class="btn btn-xs btn-grey" @click="openUploadCSV = true">Import File</button>
                                </div>
                            </div>
                        </div>

                        <div class="cart__table cart-table">
                            <return-items-list 
                            ref="rtmTable"
                            :dparts="dparts"
                            :parts="parts"
                            :btnSubmitEnable="btnSubmitEnable"
                            :btnSaveEnable="btnSaveEnable"
                            @add_to_cart="add_to_cart" :allValid="allValid"
                            @remove_item="remove_item"
                            @update_qty="update_qty"
                            @update_item_code="changeItemCode"
                            @update_mfg_code="changeMFGCode"
                            @update_email="update_email"
                            @update_reference="update_reference"
                            @update_po="update_po"
                            @submit="submit"
                            @save_list="save">
                            </return-items-list>
                        </div>
                    </div>

                    <div></div>
                </div>
            </div>
        </div>
        <div class="block-space block-space--layout--divider-order-entry"></div>
    </div>
    <div class="block-space block-space--layout--divider-thin"></div>
    <div class="block-space block-space--layout--divider-XS"></div>
    <br />
    <br />

    <base-dialog title="Upload CSV" @close="openUploadCSV = false" :open="openUploadCSV">
        <template #default>
            <div class="form-row">
                <div class="form-group col-md-12">
                    <label for="checkout-email">CSV</label>
                    <input type="file" class="form-control" id="file-csv" placeholder="CSV File">
                </div>
            </div>
        </template>
        <template #actions>
        <button type="button" class="btn btn-sm btn-secondary mr-2" @click="openUploadCSV = false">
            Cancel
        </button>
        <button type="button" class="btn btn-sm btn-primary" @click="uploadCSV">
            Yes
        </button>
        </template>
    </base-dialog>

    <base-dialog :title="savedResp.title" @close="savedResp.show = false" :open="savedResp.show">
        <template #default>
            <div class="form-row">
                <div class="form-group col-md-12">
                    <p>
                        {{savedResp.message}}
                    </p>
                </div>
            </div>
        </template>
        <template #actions>
        
        <button type="button" class="btn btn-sm btn-primary" @click="savedResp.show = false">
            OK
        </button>
        </template>
    </base-dialog>
</template>


<script>
import ReturnItemsList from './ReturnItemsList';
import axiosvl from "../../../axios/axios-vl.js";

export default {
    name: 'ReturnItems',
    components: {
        ReturnItemsList
    },
    props: {
        saved: null
    },
    data() {
        return {
            openUploadCSV: false,
            btnAddItemEnable: 'disabled',
            btnValidateEnable: 'disabled',
            btnRemoveEnable: 'disabled',

            btnSubmitEnable: 'disabled',
            btnSaveEnable: 'disabled',
            hasValidated: false,

            formData: {
                reason: '',
                retPO: '',
                email: '',
                savedDRMA: ''
            },
            
            dparts: [],
            parts: [],
            reasons: [],
            locations: [],
            minRow : 10,

            savedResp: {
                title: '',
                show: false,
                message:  ''
            },

            servermessages: [],
            errormessages: [],
        };
    },
    watch: {
        hasValidated(newVal){
            if (newVal == true){
                this.btnRemoveEnable = false;
            }else{
                this.btnRemoveEnable = 'disabled';
            }
        },
    },
    methods: {

        rmaEnabled(){
            const isEnabled = this.$store.getters['rma_enabled'];
            // const isEnabled = 'N';
            if(isEnabled == 'N'){
                this.$router.push('/return-simple');
            }
        },

        /** fetch reasons from web service */
        fetchReasons() {
            const return_reasons_uri = this.$store.getters['api/return_reasons_uri'];
            axiosvl.post(return_reasons_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": {"value": this.$store.getters.customer},
                        },
                    }
                }
            )
            .then((response) => {
                const REASONS = response.data.webroutine.lists.REASONS.entries;
                this.reasons = [];

                for (const key in REASONS) {
                    const obj = REASONS[key];
                    
                    this.reasons.push({
                        code: obj.ERREAS,
                        description: obj.ERRDSC,
                    });
                }
            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log("error - " + error);
            });
        },

        /**
         * send csv to 
         */
        uploadCSV() {
            this.openUploadCSV = false;

            // const formData = new FormData;
            const csvfile = document.getElementById('file-csv').files[0];
            const reader = new FileReader();
            const dis = this;
            let csvData = [];
            reader.addEventListener('load', (e) => {
                const data = e.target.result;
                
                let lbreak = data.split("\n");
                lbreak.forEach((res, i) => {
                    if (i != 0){
                        csvData.push(res.split(","));    
                    }          
                });
                // dis.$emit('csvUploaded', csvData);
                dis.csvUpload(csvData);
                dis.btnValidateEnable = false;
            });
            reader.readAsText(csvfile);
        },

        csvUpload(data){
            this.parts = [];
            data.forEach((row) => {
                console.log(row[0]);
                this.parts.push({
                    item : row[0],
                    quantity : parseInt(row[1]),
                    manufacturer : row[2],
                    isValid: '',
                    item_validation: '',

                    QCORE: '',
                    QCOREN: '',
                    QAPRVD: '',
                    QEXTPRC: '',
                    QITEMSZ: '',
                    QOHAND: '',
                    QSELL: '',
                    QSCOREN: '',
                    QSIZE: '',
                    QTDESC: '',
                    SLOCN: '',
                    SPARTSL: '',
                    SPNUM: '',
                    QLIST: '',
                    XRITMC: '',
                    XRMFGC: '',
                });
            });

            const rows = this.minRow - data.length;
            if (rows > 0){
                for(let i = 1; i <= rows; i++){
                    this.parts.push({});
                }
            }

            this.hasValidated = false;
            this.allValid = false;
        },

        build_list(){
            this.parts = [];
            const rows = this.minRow;
            for(let i = 1; i <= rows; i++){
                this.parts.push({
                    item : '',
                    quantity : 0,
                    manufacturer : '',
                    isValid: '',
                    item_validation: '',

                    QCORE: '',
                    QCOREN: '',
                    QAPRVD: '',
                    QEXTPRC: '',
                    QITEMSZ: '',
                    QOHAND: '',
                    QSELL: '',
                    QSCOREN: '',
                    QSIZE: '',
                    QTDESC: '',
                    SLOCN: '',
                    SPARTSL: '',
                    SPNUM: '',
                    QLIST: '',
                    XRITMC: '',
                    XRMFGC: '',
                });
            }
        },


        /**
         * validate parts from the list
         */
        validate_parts() {
            this.isloading = true;
            const paramParts = [];
            this.servermessages = [];
            
            this.dparts = [];
            this.parts.forEach(p => {
                if(p.item != null && p.item != ''){
                    const itemf = p.item.toUpperCase();
                    paramParts.push([
                        itemf,
                        p.quantity,
                        p.manufacturer
                    ]);
                } 
            });
            
            if (this.formData.reason == ''){
                this.servermessages.push("Select a Return Reason");
                return;
            }

            const return_validate_uri = this.$store.getters['api/return_validate_uri'];
            axiosvl.post(return_validate_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": {"value": this.$store.getters.customer},
                            "RETRSN": {"value": this.formData.reason},
                            "RETPO": {"value": this.formData.retPO},
                        },
                        "lists": {
                            "RPARTS": {
                                "header": [
                                    {"name": "QITEMO"},
                                    {"name": "QIOQTY"},
                                    {"name": "QMFRO"}
                                ],
                                "entries": paramParts
                            }
                        }
                    }
                }
            )
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const SPARTS = response.data.webroutine.lists.SPARTS.entries;
                const DPARTS = response.data.webroutine.lists.DPARTS.entries;
                const RESULTCOD = fields.RESULTCOD.value;
                const MSGTXT = fields.MSGTXT.value;
                const val_parts = [];
                // let hasInvalid = false;
                
                for (const key in SPARTS) {
                    const obj = SPARTS[key];

                    val_parts.push({
                        ID        : obj.QITEMO,
                        item      : obj.QITEMO,
                        desc      : obj.QITDSC,
                        manufacturer: obj.QMFR,
                        isValid: (obj.ITEMERR == "NOITEM") ? 'N' : 'Y',
                        quantity: obj.QIOQTY,
                        item_validation: obj.QITEMO + ' ' + obj.MCNAME + ' ' + obj.QITDSC,
                        MCNAME: obj.MCNAME,
                        
                        QCORE: obj.QCORE,
                        QCOREN: obj.QCOREN,
                        QAPRVD: obj.QAPRVD,
                        QEXTPRC: obj.QEXTPRC,
                        QITEMSZ: obj.QITEMSZ,
                        QOHAND: obj.QOHAND,
                        QSELL: obj.QSELL,
                        QSCOREN: obj.QSCOREN,
                        QSIZE: obj.QSIZE,
                        QTDESC: obj.QTDESC,
                        SLOCN: obj.SLOCN,
                        SPARTSL: obj.SPARTSL,
                        SPNUM: obj.SPNUM,
                        QLIST: obj.QLIST,
                        XRITMC: obj.XRITMC,
                        XRMFGC: obj.XRMFGC,
                    });
                }

                for (const key in DPARTS) {
                    const obj = DPARTS[key];
                    this.dparts.push(obj);
                }

                this.parts = val_parts;


                if(val_parts.length > 0){
                    this.btnSubmitEnable  = false;
                    this.btnSaveEnable  = false;
                }

                this.savedResp = {
                    title: 'Item Validation',
                    show: true,
                    message:  MSGTXT
                }

                if(RESULTCOD != 'OK'){
                    
                    // const wrmessages = response.data.webroutine.messages;
                    // for (var i = 0; i < wrmessages.length; i++) {
                    //     messages.push(wrmessages[i]);
                    // }
                    this.servermessages.push(MSGTXT);
                }

                

                this.hasValidated = true;
            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log("error - " + error);
            });
        },

        /**
         * submit web service
         */
        submit() {
            this.isloading = true;
            this.servermessages = [];
            const paramParts = [];
            
            this.parts.forEach(p => {
                if(p.item != null && p.item != ''){
                    paramParts.push([
                        p.item,
                        p.quantity,
                        p.manufacturer
                    ]);
                } 
            });

            const return_submit_uri = this.$store.getters['api/return_submit_uri'];
            axiosvl.post(return_submit_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": {"value": this.$store.getters.customer},
                            "RETRSN": {"value": this.formData.reason},
                            "RETPO": {"value": this.formData.retPO},
                            "SAVEDRMA": {"value": this.formData.savedDRMA},
                        },
                        "lists": {
                            "RPARTS": {
                                "header": [
                                    {"name": "QITEMO"},
                                    {"name": "QIOQTY"},
                                    {"name": "QMFRO"}
                                ],
                                "entries": paramParts
                            }
                        }
                    }
                }
            )
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const SPARTS = response.data.webroutine.lists.SPARTS.entries;
                const RESULTCOD = fields.RESULTCOD.value;
                const val_parts = [];
                const messages = [];
                // let hasInvalid = false;
                
                for (const key in SPARTS) {
                    const obj = SPARTS[key];
                    console.log(obj);
                    val_parts.push({
                        ID        : obj.QITEMO,
                        item      : obj.QITEMO,
                        desc      : obj.QITDSC,
                        manufacturer: obj.QMFR,
                        isValid: (obj.ITEMERR == "NOITEM") ? 'N' : 'Y',
                        quantity: obj.QIOQTY,
                        item_validation: obj.QITEMO + ' ' + obj.MCNAME + ' ' + obj.QITDSC,
                        MCNAME: obj.MCNAME,

                        QCORE: obj.QCORE,
                        QCOREN: obj.QCOREN,
                        QAPRVD: obj.QAPRVD,
                        QEXTPRC: obj.QEXTPRC,
                        QITEMSZ: obj.QITEMSZ,
                        QOHAND: obj.QOHAND,
                        QSELL: obj.QSELL,
                        QSCOREN: obj.QSCOREN,
                        QSIZE: obj.QSIZE,
                        QTDESC: obj.QTDESC,
                        SLOCN: obj.SLOCN,
                        SPARTSL: obj.SPARTSL,
                        SPNUM: obj.SPNUM,
                        QLIST: obj.QLIST,
                        XRITMC: obj.XRITMC,
                        XRMFGC: obj.XRMFGC,
                    });
                }

                this.parts = val_parts;

                this.savedResp = {
                    title: 'Return Submitted',
                    show: true,
                    message:  "Your returns request has been received.  Please contact Customer Service for further inquiries on your returns."
                }
                
                if(RESULTCOD == 'OK'){
                    this.savedResp = {
                        title: 'Return Submitted',
                        show: true,
                        message:  "Your returns request has been received.  Please contact Customer Service for further inquiries on your returns."
                    }
                }else{
                    const wrmessages = response.data.webroutine.messages;
                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }
                }

                this.servermessages = messages;
                this.hasValidated = true;

                // console.table(val_parts);
            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log("error - " + error);
            });
        },

        /** load web service */
        async load() {
            this.isloading = true;

            const return_load_uri = this.$store.getters['api/return_load_uri'];
            await axiosvl.post(return_load_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": {"value": this.$store.getters.customer},
                            "SAVEDRMA": {"value": this.saved},
                        },
                    }
                }
            )
            .then((response) => {
                const SPARTS = response.data.webroutine.lists.SPARTS.entries;
                const val_parts = [];
                // let hasInvalid = false;
                
                for (const key in SPARTS) {
                    const obj = SPARTS[key];

                    val_parts.push({
                        ID        : obj.QITEMO,
                        item      : obj.QITEMO,
                        desc      : obj.QITDSC,
                        manufacturer: obj.QMFR,
                        isValid: (obj.ITEMERR == "NOITEM") ? 'N' : 'Y',
                        quantity: obj.QIOQTY,
                        item_validation: obj.QITEMO + ' ' + obj.MCNAME + ' ' + obj.QITDSC,
                        MCNAME: obj.MCNAME,

                        QCORE: obj.QCORE,
                        QCOREN: obj.QCOREN,
                        QAPRVD: obj.QAPRVD,
                        QEXTPRC: obj.QEXTPRC,
                        QITEMSZ: obj.QITEMSZ,
                        QOHAND: obj.QOHAND,
                        QSELL: obj.QSELL,
                        QSCOREN: obj.QSCOREN,
                        QSIZE: obj.QSIZE,
                        QTDESC: obj.QTDESC,
                        SLOCN: obj.SLOCN,
                        SPARTSL: obj.SPARTSL,
                        SPNUM: obj.SPNUM,
                        QLIST: obj.QLIST,
                        XRITMC: obj.XRITMC,
                        XRMFGC: obj.XRMFGC,
                    });
                }

                this.parts = val_parts;

                const rows = this.minRow - val_parts.length;
                if (rows > 0){
                    for(let i = 1; i <= rows; i++){
                        this.parts.push({});
                    }
                }

                this.btnSubmitEnable  = false;
                this.btnSaveEnable  = false;
                this.btnValidateEnable = false;
                this.hasValidated = false;
                
                setTimeout(() => {
                    this.$refs.rtmTable.loadTable();    
                }, 500);
                
            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log(error);
            });
        },

        /** save web service */
        save() {
            this.isloading = true;
            this.servermessages = [];
            const paramParts = [];
            
            this.parts.forEach(p => {
                if(p.item != null && p.item != ''){
                    paramParts.push([
                        p.item,
                        p.quantity,
                        p.manufacturer
                    ]);
                } 
            });

            const return_saved_uri = this.$store.getters['api/return_saved_uri'];
            axiosvl.post(return_saved_uri, {
                    "webroutine": {
                        "context": {
                            "session-key-method": "hidden"
                        },
                        "fields": {
                            "EHCUST": {"value": this.$store.getters.customer},
                            "RETRSN": {"value": this.formData.reason},
                            "RETPO": {"value": this.formData.retPO},
                            "SAVEDRMA": {"value": this.saved},
                        },
                    }
                }
            )
            .then((response) => {
                const fields = response.data.webroutine.fields;
                const RESULTCOD = fields.RESULTCOD.value;
                const messages = [];
                if(RESULTCOD == 'OK'){
                    let message = 'Return items are saved.';
                    if(response.data.webroutine.messages !=  undefined){
                        message = response.data.webroutine.messages[0];
                    }

                    this.savedResp = {
                        title: 'Return Saved',
                        show: true,
                        message:  message
                    }
                }
                
                if(response.data.webroutine.messages !=  undefined){
                    const wrmessages = response.data.webroutine.messages;

                    for (var i = 0; i < wrmessages.length; i++) {
                        messages.push(wrmessages[i]);
                    }
                }

                this.servermessages = messages;
                
            })
            .catch((error) => {
                this.isloading = false;
                this.servermessages.push('Something went wrong. Please try again later.');
                console.log("error - " + error);
            });
        },

        remove_invalid() {
            const valid_parts = [];
            this.parts.forEach(i => {
                if(i.isValid == 'Y'){
                    valid_parts.push(i);
                }
            });
            this.allValid = true;
            this.parts = valid_parts;
        },

        remove_item(index){
            this.parts.splice(index, 1);
        },

        update_qty(index, newQty){
            this.parts.filter((part, indx) => {
                if(indx == index){
                    part.quantity = newQty;
                }
            });
        },

        changeItemCode(index, newVal){
            this.btnValidateEnable = false;
            this.parts.filter((part, indx) => {
                if(indx == index){
                    part.item = newVal;
                    part.isValid = '';
                    this.needValidateParts = true;
                    this.allValid = false;
                }
            });
        },

        changeMFGCode(index, newVal){
            this.btnValidateEnable = false;
            this.parts.filter((part, indx) => {
                if(indx == index){
                    part.manufacturer = newVal;
                    part.isValid = '';
                    this.needValidateParts = true;
                    this.allValid = false;
                }
            });
        },

        update_email(email) {
            this.formData.email = email;
        },
        update_reference(savedDRMA) {
            this.formData.savedDRMA = savedDRMA;
        },
        update_po(retPO) {
            this.formData.retPO = retPO;
        },
        
        /**
         * adds more blank rows on the form
         */
        expand() {
            this.parts.push({
                item : '',
                quantity : 0,
                manufacturer : '',
                isValid: '',
                item_validation: '',
                MCNAME: '',
                QCORE: '',
                QCOREN: '',
                QAPRVD: '',
                QEXTPRC: '',
                QITEMSZ: '',
                QOHAND: '',
                QSELL: '',
                QSCOREN: '',
                QSIZE: '',
                QTDESC: '',
                SLOCN: '',
                SPARTSL: '',
                SPNUM: '',
                QLIST: '',
                XRITMC: '',
                XRMFGC: '',
            });
        }

    },

    created() {
        this.rmaEnabled();

        this.fetchReasons();
        this.build_list();
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });

        if(this.saved != ""){
            this.load();
        }
    }
}
</script>